import { render, staticRenderFns } from "./economic-programming-import.vue?vue&type=template&id=6748d50e&scoped=true"
import script from "./economic-programming-import.vue?vue&type=script&lang=js"
export * from "./economic-programming-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6748d50e",
  null
  
)

export default component.exports